// v1.0.0 - 2026-01-27 - Badge component

import { type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils/cn'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info'
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  const variants = {
    default:
      'bg-[var(--color-bg-tertiary)] text-[var(--color-text-secondary)]',
    success:
      'bg-[var(--color-bg-success)] text-[var(--color-success)]',
    warning:
      'bg-[var(--color-bg-warning)] text-[var(--color-warning)]',
    error:
      'bg-[var(--color-bg-error)] text-[var(--color-error)]',
    info:
      'bg-blue-100 text-blue-700',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className
      )}
      {...props}
    />
  )
}
